import { createRoute } from '@tanstack/react-router';
import { ReportClaim } from '../report-claim/index.js';
import { rootRoute } from './index.js';

export const reportClaimRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/report-claim',
    component: ReportClaim,
});
